import { logger } from "@platform/browser-logger";

import type {
  FilterModel,
  IServerSideDatasource,
  IServerSideGetRowsParams,
  SortModelItem,
} from "ag-grid-community";

export interface FetchPageParams {
  page: number;
  pageSize: number;
  sortModel: SortModelItem[];
  filterModel: FilterModel | null;
}

interface FetchPageResult<T> {
  rows: T[];
  total: number;
}

type FetchPageFn<T> = (params: FetchPageParams) => Promise<FetchPageResult<T>>;

export function createServerSideDatasource<T>(
  fetchPage: FetchPageFn<T>,
): IServerSideDatasource {
  return {
    getRows: async (params: IServerSideGetRowsParams) => {
      try {
        const { startRow, endRow, sortModel, filterModel } = params.request;
        const pageSize = (endRow || 0) - (startRow || 0);
        const page = Math.floor((startRow || 0) / pageSize);

        const result = await fetchPage({
          page,
          pageSize,
          sortModel,
          filterModel,
        });

        params.success({ rowData: result.rows, rowCount: result.total });
      } catch (error) {
        logger.error(
          "Error fetching data:",
          error instanceof Error ? error : new Error(String(error)),
        );
        params.fail();
      }
    },
  };
}
